import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {reGenerateLabel} from "../../../services/api/apiNextBox"
import ModalMessage from "./notication/ModalMessage"
import isSameBarcodeNumber from "../helpers/isSameBarcodeNumber"

class ReGenLabel extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            isOpen: false,
            isRegen: false
        }
    }

    _isClose = () => {
        this.setState({
            isOpen: false
        })
    }

    _reGenerateLabel = async () => {
        this.setState({
            loading: true,
            error: '',
            message: ''
        })

        try {
            const {arrBarcodes} = this.props
            const checkSame = isSameBarcodeNumber(arrBarcodes)

            if (checkSame !== false) {
                this.setState({
                    barcodeRegen: checkSame
                }, async () => {
                    const {barcodeRegen} = this.state
                    const responsive = await reGenerateLabel(barcodeRegen[0])

                    const {data, success, message} = responsive

                    if (!success) {
                        return this.setState({
                            loading: false,
                            error: message,
                            isOpen: true
                        })
                    }

                    this.setState({
                        loading: false,
                        message: data.message,
                        isRegen: data.hasOwnProperty('order'),
                        isOpen: true
                    })
                })
            } else {
                this.setState({
                    isOpen: true,
                    loading: false,
                    error: 'Bạn đã nhập/quét barcode ở 2 order khác nhau vui lòng kiểm tra lại',
                })
            }

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
                isOpen: true
            })
        }
    }

    render() {
        const {arrBarcodes} = this.props
        const {loading, error, message, isOpen, isRegen} = this.state

        return (
            <div className='ReGenLabel d-flex align-items-center'>
                {
                    arrBarcodes.length > 0 &&
                    <Button color='primary' size='sm' onClick={this._reGenerateLabel}>
                        {loading && <i className='fa fa-spinner fa-spin mr-1'/>}
                        Gen label
                    </Button>
                }

                <ModalMessage isOpen={isOpen} message={message} error={error} onClose={this._isClose}
                              isRegen={isRegen}/>
            </div>
        )
    }
}

ReGenLabel.propTypes = {
    arrBarcodes: PropTypes.array
}

export default ReGenLabel
